'use client';

import type { VstackProps } from '@terra/ui-styled-system';
import { VStack, token, Box } from '@terra/ui-styled-system';
import { Text } from '@terra/ui-design-system';
import { Activity01Icon } from '@terra/ui-icons';

type NoDataProps = {
  title?: string;
  description?: string;
} & VstackProps;

export const NoData = ({
  title,
  description,
  ...restProps
}: NoDataProps = {}) => {
  return (
    <VStack
      gap={4}
      alignItems="center"
      justifyContent="center"
      w="full"
      h="full"
      {...restProps}
    >
      <Activity01Icon size={24} color={token('colors.neutral.12')} />
      <Box textAlign="center">
        <Text color="fg.neutral.muted">{title ?? 'No data available'}</Text>
        <Text color="fg.neutral.muted">{description ?? ''}</Text>
      </Box>
    </VStack>
  );
};
